// export const SERVER_URL = "http://172.104.173.184:3022";
// export const SERVER_URL = "https://panelapi.charmbykaalo.com";
export const SERVER_URL = "https://charmapi.charmbykaalo.com";